export default __webpack_public_path__ + "images/confirmation_lpppreview.55ffbed6.png";